module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view-port clearfix",
    attrs: {
      "id": "chat"
    }
  }, [_c('div', {
    staticClass: "view bg-white"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('div', {
    staticClass: "list-view boreded no-top-border",
    attrs: {
      "data-init-list-view": "ioslist"
    }
  }, _vm._l((_vm.groups), function(group) {
    return _c('div', {
      staticClass: "list-view-group-container"
    }, [_c('div', {
      staticClass: "list-view-group-header text-uppercase"
    }, [_vm._v(_vm._s(group.title))]), _vm._v(" "), _c('ul', _vm._l((group.items), function(item) {
      return _c('li', {
        staticClass: "chat-user-list clearfix"
      }, [_c('a', {
        attrs: {
          "data-view-animation": "push-parrallax",
          "data-view-port": "#chat",
          "data-navigate": "view",
          "href": "#"
        }
      }, [_vm._m(1, true, false), _vm._v(" "), _c('p', {
        staticClass: "p-l-10 col-xs-height col-middle col-xs-12"
      }, [_c('span', {
        staticClass: "text-master"
      }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('span', {
        staticClass: "block text-master hint-text fs-12"
      }, [_vm._v(_vm._s(item.message))])])])])
    }))])
  }))]), _vm._v(" "), _c('Conversation')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar navbar-default"
  }, [_c('div', {
    staticClass: "navbar-inner"
  }, [_c('a', {
    staticClass: "inline action p-l-10 link text-master",
    attrs: {
      "href": "javascript:;",
      "data-navigate": "view",
      "data-view-port": "#chat",
      "data-view-animation": "push-parrallax"
    }
  }, [_c('i', {
    staticClass: "pg-plus"
  })]), _vm._v(" "), _c('div', {
    staticClass: "view-heading"
  }, [_vm._v("\n          Chat List\n          "), _c('div', {
    staticClass: "fs-11"
  }, [_vm._v("Show All")])]), _vm._v(" "), _c('a', {
    staticClass: "inline action p-r-10 pull-right link text-master",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "pg-more"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "col-xs-height col-middle"
  }, [_c('span', {
    staticClass: "thumbnail-wrapper d32 circular bg-success"
  }, [_c('img', {
    staticClass: "col-top",
    attrs: {
      "width": "34",
      "height": "34",
      "alt": "",
      "data-src-retina": "../assets/img/profiles/1x.jpg",
      "data-src": "../assets/img/profiles/1.jpg",
      "src": require("../assets/img/profiles/1x.jpg")
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11310d1b"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/chat.vue
// module id = 1361
// module chunks = 1